import {
  AfterViewChecked,
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild
} from '@angular/core';
import { PersonApplication } from 'src/app/shared/models/application/personApplication';
import { Attribute } from 'src/app/shared/models/attributes/attribute';
import { KeyValue } from '@angular/common';

@Component({
  selector: 'app-portal-form-details',
  templateUrl: './portal-form-details.component.html',
  styleUrls: ['./portal-form-details.component.scss'],
  standalone: false
})
export class PortalFormDetailsComponent implements AfterViewChecked {
  public isLoading: boolean = true;
  public application: PersonApplication;
  public systemFields: KeyValue<string, string>[];
  public customFields: Attribute[];
  private shouldFocusHeading = false;
  public personId: string;

  @Output() closed = new EventEmitter<void>();
  @ViewChild('panelHeading') panelHeading: ElementRef<HTMLElement>;
  constructor() {}

  open(application: PersonApplication) {
    this.isLoading = true;
    this.shouldFocusHeading = true;

    this.setApplication(application);
    this.isLoading = false;
  }

  ngAfterViewChecked(): void {
    if (this.shouldFocusHeading && this.panelHeading?.nativeElement) {
      setTimeout(() => {
        //the animation for opening the side panel takes 400ms.
        //focusing before it's done causes the elements to jump.
        this.panelHeading.nativeElement.focus();
      }, 500);

      this.shouldFocusHeading = false;
    }
  }
  get isFirmForm(): boolean {
    return this.application?.isFirmForm ?? false;
  }

  getCustomFields() {
    if (this.application) {
      this.customFields = Attribute.fromKeyValue(this.application.customFieldsSnapshot);
    }
  }

  getSystemFields() {
    if (this.application) {
      this.systemFields = this.application.systemFieldsSnapshot;
    }
  }

  close(): void {
    this.closed.emit();
  }

  private setApplication(application: PersonApplication) {
    this.application = application;
    if (this.application) {
      this.getCustomFields();
      this.getSystemFields();
    }
  }
}
